import React, { useState } from "react";

import PortfolioItemFrame from "./portfolioItemFrame";
import Button from "./button";

export default ({ portfolioItems, sectionName, heading }) => {
  const [limit, updateLimit] = useState(6);
  return (
    <section
      className="colorlib-work"
      data-section={sectionName.replace(/[^a-zA-Z0-9]/, "-")}
      id={sectionName.replace(/[^a-zA-Z0-9]/, "-")}
    >
      <div className="colorlib-narrow-content">
        <div className="row">
          <div className="col-md-6 col-md-offset-3 col-md-pull-3">
            <span className="heading-meta">{sectionName}</span>
            <h2 className="colorlib-heading">{heading}</h2>
          </div>
        </div>
        <div className="row">
          {portfolioItems
            .filter((item, i) => i < limit)
            .map(item => <PortfolioItemFrame {...item} key={item.name} />)}
        </div>
        {portfolioItems.length > limit ? (
          <Button
            buttonText="Load more"
            icon="reload"
            onClick={() => updateLimit(limit + 3)}
          />
        ) : (
          ""
        )}
      </div>
    </section>
  );
};



// WEBPACK FOOTER //
// ./src/components/portfolioContainer.js